import type { Commit } from 'vuex';

interface State {
  accepted: boolean;
}

const state = (): State => ({
  accepted: false,
});

const actions = {
  accept({ commit }: { commit: Commit }) {
    commit('TOGGLE_COOKIE_POLICY', true);
  },
};

const mutations = {
  TOGGLE_COOKIE_POLICY(state: State, value: boolean) {
    state.accepted = value;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
